import React from "react";
import { useLang } from "@/lib/LangContext";
import { BUSINESS } from "@/lib/business";
import Logo from "@/components/Logo";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function Footer() {
  const { lang } = useLang();
  return (
    <footer className="border-t border-[#6B1F27]/15 mt-24 bg-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3" translate="no">
            <Logo size={40} variant="dark" />
            <div className="font-display text-2xl tracking-tighter notranslate" translate="no">{BUSINESS.name}</div>
          </div>
          <div className="tick-label mt-3">{BUSINESS.tagline[lang]}</div>
          <div className="mt-4 text-sm">
            <div className="font-semibold">{BUSINESS.owner.name}</div>
            <div className="text-neutral-500 text-xs mt-0.5">{BUSINESS.owner.role[lang]}</div>
          </div>
        </div>

        <div className="text-sm">
          <div className="tick-label mb-3">{lang === "es" ? "Contacto" : "Contact"}</div>
          <a href={`tel:${BUSINESS.phone_raw}`} className="flex items-center gap-2 mt-2 hover:text-[#6B1F27]" data-testid="footer-phone">
            <Phone size={14} /> <span className="font-mono-tight">{BUSINESS.phone_display}</span>
          </a>
          <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 mt-2 hover:text-[#6B1F27]" data-testid="footer-email">
            <Mail size={14} /> {BUSINESS.email}
          </a>
        </div>

        <div className="text-sm">
          <div className="tick-label mb-3">{lang === "es" ? "Dirección" : "Address"}</div>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BUSINESS.address.maps_query)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-2 hover:text-[#6B1F27]"
            data-testid="footer-address"
          >
            <MapPin size={14} className="mt-0.5 shrink-0" />
            <span>
              {BUSINESS.address.street}
              <br />
              {BUSINESS.address.city}, {BUSINESS.address.state} {BUSINESS.address.zip}
            </span>
          </a>
        </div>

        <div className="text-sm">
          <div className="tick-label mb-3">{lang === "es" ? "Horario" : "Hours"}</div>
          <ul className="space-y-1" data-testid="footer-hours">
            {BUSINESS.hours[lang].map((h) => (
              <li key={h.days} className="flex items-start gap-2">
                <Clock size={14} className="mt-1 shrink-0 text-neutral-400" />
                <span>
                  <span className="font-medium">{h.days}</span>
                  <span className="text-neutral-500 ml-1">· {h.time}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#6B1F27]/15 py-5 text-center tick-label">
        © {new Date().getFullYear()} {BUSINESS.name} · {lang === "es" ? "Todos los derechos reservados" : "All rights reserved"}
      </div>
    </footer>
  );
}
